const calculateHeaderHeight = () => document?.querySelector(".header")?.clientHeight || //if the regular header height is 0 we check the mobile header
document?.querySelector(".header__header")?.clientHeight || 0;
export {
  calculateHeaderHeight
};
//# sourceMappingURL=calculate-header-height.js.map
